<script>
import { Autoplay, FreeMode } from 'swiper/modules'

export default {
  setup(props, { slots }) {
    return () => slots.default({
      modules: [Autoplay, FreeMode]
    })
  }
}
</script>